import React from 'react'
import Image from "next/image";
import styles from "./tnpsc-admissions.module.css";
import SUBATHRA from "../../assets/images/Tnpsc/subathra-2026.jpg";
import HARIPRIYANKKA from "../../assets/images/Tnpsc/HARI-PRIYANKKA-3rd-Rank-2025.png";
import KERANAPUK from "../../assets/images/Tnpsc/KERANAPUK-LYTHIA-4thRank-2025.png";
import Link from 'next/link';
import Icon from "../../assets/images/Tnpsc/tnpsc-icon.png";
import Emioption from "../../components/Service/emioption";

const About_TNPSC = () => {
 
    const prelimslist1 =[
        {cont:"Exhaustive coaching - ",cont1:"More than 150 classes of 150 minutes each for Prelims."},
        {cont:"Extensive Class Test - ",cont1:"25 Preliminary Test - Online Test with video solution."},
        {cont:"Highly Qualified and Experienced Trainers - ",cont1:"Faculty members who have vast experience in TNPSC Examinations."},
        {cont:"Class Instruction - ",cont1:"Bilingual Mode Only"},
        {cont:"Student- Achiever Interactions - ",cont1:"Regular interaction of students with succesful working Group I officers. "},
        {cont:"Mentoring Programme - ",cont1:"Scheduled Mentoring Programme by expert faculty and service candidates. Continuous evaluation of students and provision of mentoring to students who are lacking in subjects. "},
        {cont1:"Provision of Concept Sheets for the required subjects."},
        {cont1:"Focuses on Current Affairs, Articles,etc based on the dynamics of TNPSC examination."},
        {cont1:"Disciplined and adoptable approach."}  
    ]

    const prelimslist2 =[
        {cont1:"Integrated Foundation course  for TNPSC Groups I  Prelim and Main  Examinations  2027"},
        {cont1:"Systematic Coverage of  Groups ,I, II, IIA, & IV - Preliminary and Group I Main syllabus."},
        {cont1:"12+ month duration, 6 days of classes per week. Tests are on weekends. Extra classes will be conducted if required to complete the syllabus. "},
        {cont1:"Over 230 + structured  classes conducted by a team of experienced faculty."},
        {cont1:"Updated study materials that align with the TNPSC Preliminary and Main syllabus"},
        {cont1:"For practice, there are over 75+  preliminary tests for Groups I and II available on the online platform."},
        {cont1:"General Tamil and English will be covered in the Group II, II A & IV Exams on weekdays or weekends. Timings  may vary  on the language class selection by the student. "},
        {cont1:"Class videos will remain accessible for 30 days to  help students revise the subjects more effectively. "},
        {cont1:"The Tnpsc-Group-II & II A Main Syllabus will not be covered in this program.  "},
        {cont1:"The foundation program is exclusively designed for new students preparing for the TNPSC  2027  examinations."},
    ]

  return (
    <>

    <section id="coursedetails">
        <div className="container pt-lg-1">
            <div className="row" id="gspcm" style={{paddingTop: "90px"}}>
                <div className="col-lg-6 col-md-12">
                    <div className="row">
                        <div className='col'>  
                            <div className='row '>
                                <h3 className={`${styles.pagegspcm}`}>TNPSC Gr I Preliminary & Mains (PCM) </h3> 
                                <table className="table">
                                    <tbody>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular - Offline & Online</span></td>
                                                <td className={`${styles.tablepara}`}>07.10.2026 <br/><p className={`${styles.tablepara}`}>02:00 pm to 05:00 pm </p></td>
                                                <td className={`${styles.tablepara} `}>₹1,00,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            {/* <tr>
                                                <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular - Offline & Online</span></td>
                                                <td className={`${styles.tablepara}`}>27.08.2026 <br/><p className={`${styles.tablepara}`}>10:30 am to 01:30 pm </p></td>
                                                <td className={`${styles.tablepara} `}>₹1,00,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular - Offline & Online</span></td>
                                                <td className={`${styles.tablepara}`}>10.07.2026 <br/><p className={`${styles.tablepara}`}>02:00 pm to 05:00 pm </p></td>
                                                <td className={`${styles.tablepara} `}>₹1,00,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr> */}


                                            {/* <tr>
                                                <td className={`${styles.tableheading}`}>Anna Nagar<br/><span className={`${styles.tablepara}`}>Regular -  Online</span></td>
                                                <td className={`${styles.tablepara}`}>18.06.2026 <br/><p className={`${styles.tablepara}`}>10:30 am to 01:30 pm </p></td>
                                                <td className={`${styles.tablepara} `}>₹1,00,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr> */}

                                    </tbody>
                                </table>
                            </div>

                            <div className="row pt-2">
                                <div className="col">
                                    <h3 className={`${styles.highlightbtn}`}>TNPSC PCM  2026-2027 - Integrated Foundation Course - Highlights:</h3>
                                    <ul className={`${styles.ulclass1} ps-1 pt-2 mb-0`}>
                                        {prelimslist2.map((item,index)=>(
                                        <li className={`${styles.ulliclass1} ${styles.siaacheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                            <div className="d-inline">
                                                <p className={`${styles.ullispan1} d-inline`}>
                                                <span className={`${styles.acheiverrank}`}> {item.cont1}</span>
                                                </p>
                                            </div>
                                        </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>           
                        </div>  
                    </div>
                
                    <div className="col-xl-6 pt-2">
                        <button className={`${styles.normalbluebutton}`} type="submit">Our achievements</button>
                    </div>

                    <div className="col-xl-6 pt-3 pt-lg-5">
                        <h3 className={`${styles.pagemaintitles}`}>TNPSC toppers</h3> 
                    </div>

                    <div className="row pt-3">
                        <div className='col-md-6'>
                            <Image src={Icon} className="img-fluid w-100" alt="Tnpsc Icon" title="Tnpsc Icon"/>
                        </div>
                    </div>

                    <div className='row' id="topperlist">
                        <div className='col'>
                            <p className={`${styles.titles} pt-3 mb-5`}>TNPSC candidates selected for Group I, II & IV services from our academy.</p>
                        </div>
                    </div>
                            
                    <div className="row">
                        <div className='col'>
                            <div className='row pt-3'>
                                    <div className="col-md-4 text-center">
                                        <div className={`${ styles.toppersupsc}`}> 
                                            <div><Image src={SUBATHRA} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" /></div>
                                            <span1></span1> 
                                            <p className={`${styles.acheivername} text-center mb-0`}>SUBATHRA K</p>
                                            <p className={`${styles.acheiverrank}  text-center mb-0`}>State Rank - 4 (2025)</p>
                                            <p className={`${styles.acheiverrank1}  text-center mb-0`}>Interview Program</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center">
                                        <div className={`${ styles.toppersupsc}`}>
                                            <div><Image src={HARIPRIYANKKA} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" /></div>
                                            <span1></span1>
                                            <p className={`${styles.acheivername} text-center mb-0`}>HARI PRIYANKKA N</p>
                                            <p className={`${styles.acheiverrank} text-center mb-0`}>State Rank - 2 (2024)</p>
                                            <p className={`${styles.acheiverrank1} text-center mb-0`}>Test Series & Interview Program</p>   
                                        </div>
                                    </div>
                                    <div className="col-md-4 text-center">
                                        <div className={`${ styles.toppersupsc}`}>
                                            <div><Image src={KERANAPUK} className="img-fluid" alt="Tnpsc_toppers" title="Tnpsc_toppers" /> </div>
                                            <span1></span1>
                                            <p className={`${styles.acheivername} text-center mb-0`}>KERANAPUK LYTHIA P</p>
                                            <p className={`${styles.acheiverrank}  text-center mb-0`}>State Rank - 4 (2024)</p>
                                            <p className={`${styles.acheiverrank1}  text-center mb-0`}>Interview Program</p>
                                        </div>
                                    </div>
                            </div>

                            <br/>

                            <Link href={"/our-achievers"} className={`${styles.morelink}`}>& More...</Link>
                        </div>  
                    </div>
                </div>

                <div className="col-lg-6 col-md-12">
                    <h4 className={`${styles.pagemaintitle} pt-3 pt-lg-0`}>TNPSC Group I & II Preliminary</h4>
                    <div className='row prelimstable'>
                        <div className='col'>
                            <div className={`${styles.tablescroll}`}>
                                <table className="table">
                                        <tbody>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Anna Nagar <br/><span className={`${styles.tablepara}`}>Weekend <br/>(Saturday & Sunday only)<br />(Offline & Online)</span></td>
                                                <td className={`${styles.tablepara}`}>24.10.2026<br/><p className={`${styles.tablepara}`}> 02:00 pm to 08:30 pm</p></td>
                                                <td className={`${styles.tablepara} `}>₹48,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>
                                           
                                            <tr>
                                                <td className={`${styles.tableheading}`}>Adyar <br/><span className={`${styles.tablepara}`}>Regular <br/>(Offline & Online)</span></td>
                                                <td className={`${styles.tablepara}`}>30.09.2026<br/><p className={`${styles.tablepara}`}> 10:30 am to 01:30 pm</p></td>
                                                <td className={`${styles.tablepara} `}>₹48,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Adyar&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Salem <br/><span className={`${styles.tablepara}`}>Regular(Offline)</span></td>
                                                <td className={`${styles.tablepara}`}>09.10.2026<br/><span className={`${styles.tablepara}`}>10:00 am to 01:00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Salem&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                             <tr>
                                                <td className={`${styles.tableheading}`}>Madurai <br/><span className={`${styles.tablepara}`}>Regular(Offline)</span></td>
                                                <td className={`${styles.tablepara}`}>30.10.2026<br/><span className={`${styles.tablepara}`}>10:00 am to 01:00pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Trichy <br/><span className={`${styles.tablepara}`}>Regular(Offline)</span></td>
                                                <td className={`${styles.tablepara}`}>30.10.2026<br/><span className={`${styles.tablepara}`}>02:00 pm to 05:00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                              <tr>
                                                <td className={`${styles.tableheading}`}>Namakkal <br/><span className={`${styles.tablepara}`}>Regular(Offline) </span></td>
                                                <td className={`${styles.tablepara}`}>16.10.2026<br/><span className={`${styles.tablepara}`}>02:00 pm to 05:00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹32,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            {/* <tr>
                                                <td className={`${styles.tableheading}`}>Trichy <br/><span className={`${styles.tablepara}`}>Regular(Offline)</span></td>
                                                <td className={`${styles.tablepara}`}>03.08.2026<br/><span className={`${styles.tablepara}`}>10:30 am to 01:30 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr> */}


                                            <tr>
                                                <td className={`${styles.tableheading}`}>Thiruvarur<br/><sapn className={`${styles.tablepara}`}>Regular(Offline)</sapn></td>
                                                <td className={`${styles.tablepara}`}>14.09.2026<br/><span className={`${styles.tablepara}`}>10.00 am to 01.00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹32,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Thiruvarur&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Coimbatore<br/><span className={`${styles.tablepara}`}>Regular </span></td>
                                                <td className={`${styles.tablepara}`}>12.10.2026<br/><span className={`${styles.tablepara}`}>9:30 am to 12.30 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr> 


                                            <tr>
                                                <td className={`${styles.tableheading}`}>Coimbatore<br/><span className={`${styles.tablepara}`}>Regular </span></td>
                                                <td className={`${styles.tablepara}`}>03.09.2026<br/><span className={`${styles.tablepara}`}>10:00 am to 01:00pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr> 

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Coimbatore<br/><span className={`${styles.tablepara}`}>Weekend</span></td>
                                                <td className={`${styles.tablepara}`}>03.09.2026<br/><span className={`${styles.tablepara}`}>05:00 pm to 08:00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                            

                                            <tr>
                                                <td className={`${styles.tableheading}`}>Coimbatore<br/><span className={`${styles.tablepara}`}>Evening </span></td>
                                                <td className={`${styles.tablepara}`}>01.10.2026<br/><span className={`${styles.tablepara}`}>05:00 pm to 08:00 pm</span></td>
                                                <td className={`${styles.tablepara} `}>₹35,000</td>
                                                <td><Link href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" className={`${styles.paybill}`}>Pay Now</Link></td>
                                            </tr>

                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-12 pt-4">
                        <Emioption />
                    </div>

                    <div className="container">
                        <div className="row pt-3">
                            <div className="col">
                                <p className={`${styles.aboutparagraph1} p-2`}><span className={`${styles.dot}`}>*</span>&nbsp; &nbsp; <span>(Class Instruction - Bilingual Mode Only)</span></p>                        
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <ul className={`${styles.ulclass1} ps-1 pt-2 mb-0`}>
                                {prelimslist1.map((item,index)=>(
                                <li className={`${styles.ulliclass1} ${styles.siaacheiverrank}`} key={index} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan1} d-inline`}>
                                        <span className={`${styles.acheivernames} `}>{item.cont} &nbsp;</span><span className={`${styles.acheiverranks}`}> {item.cont1}</span>
                                        </p>
                                    </div>
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <hr></hr>
        </div>
    </section>

    </>
  )
}
export default About_TNPSC;